// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1YGun","content":"styles_content__2k6P4","selectAll":"styles_selectAll__1YmSD"};